import React, { useEffect, useState } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import PreEFormGrid from './PreEFormGrid';
import PreEFormTasks from './PreEFormTasks';
import PreEFormExceptionGrid from '../PreEForm/PreEFormExceptionGrid';
import PreEApprovals from './PreEFormExceptionGrid/Approvals';
import { confirmAlert } from 'react-confirm-alert';
import 'react-datepicker/dist/react-datepicker.css';
import {
    createPreform, energizationPreEForm,
    getNewPreform, getOutageRecord,
    getPreEFormExceptions,
    getPreform,
    getPreformEdit,
    getPreforms,
    undoPreEFormEnergization,
    updatePreform
} from '../../api/PreEForm';
import Moment from 'moment';
import PreEFormDetails from './PreEFormDetails';
import Button from '../../components/Button';
import ShowPreEFormDeleteDialog from './PreEFormDeleteDialog';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import Alert from '../../components/Alert';
import {downloadPreEngPdfReport} from "../../api/Pdf"

export const FORM_MODE_VIEW = 0;
export const FORM_MODE_EDIT = 1;
export const FORM_MODE_NEW = 2;

function PreEForm(props) {
    const {project, location, status, refreshPreEForms, setRefreshPreEForms} = props;

    const [preEForm, setPreEForm] = useState(null);
    const [preEFormExceptions, setPreEFormExceptions] = useState(null);
    const [preEFormMappings, setPreEFormMappings] = useState(null);
    const [forms, setForms] = useState([]);
    const [error, setError] = useState(null);
    const [asset, setAsset] = useState(null);
    const [formId, setFormId] = useState('');
    const [formMode, setFormMode] = useState(FORM_MODE_VIEW);
    const [saveVisibleText, setSaveVisibleText] = useState(false);
    const [refresh, setRefresh] = useState(true);

    useEffect(() => {
        async function getData() {
            const allForms = await getPreforms(project.id);
            if (preEFormExceptions === null) {
                const pathSplit = location.pathname.split("/");
                if (pathSplit[pathSplit.length - 1] === "exceptions") {
                    await updateExceptionsState(pathSplit[pathSplit.length - 2]);
                } else if (pathSplit[pathSplit.length - 1] === "" && pathSplit[pathSplit.length - 2] === "exceptions") {
                    await updateExceptionsState(pathSplit[pathSplit.length - 3]);
                }
            }
            setForms(allForms);
            setRefresh(false);
            setRefreshPreEForms(false);
        }

        if (refreshPreEForms || refresh) getData();
    }, [refresh, refreshPreEForms])


    function handleRefreshCall() {
        setRefresh(true);
    }

    async function updateFormState() {
        const updatedForms = await getPreforms(project.id);
        setForms(updatedForms)
    }

    async function updateExceptionsState(formId) {
        spinnerOn();
        const preEForm = await getPreform(project.id, formId);
        setPreEForm(preEForm);
        const exceptions = await getPreEFormExceptions(formId);
        setPreEFormExceptions(exceptions);
        spinnerOff();
    }

    async function handlePreExceptionBack() {
        await updateFormState();
        props.history.push(`/${status}/${project.id}/peform`);
    }

    async function deleteForm (form) {
        const exceptions = await getPreEFormExceptions(form.id);
        if(exceptions && exceptions.length > 0) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                      <div className="react-confirm-alert-body">
                          <p> This Pre-Energization Form cannot be deleted, It has exception form(s).</p>
                          <br />
                          <br />
                          <div className="btn ok-2">
                              <Button
                                className="btn btn-primary start-5"
                                onClickHandler={onClose}
                              > Ok </Button>
                          </div>
                      </div>
                    );
                }
            });
        } else {
            ShowPreEFormDeleteDialog(project.id, form.id, form.formName, form.reqSos, form.preEnergizationDate, updateFormState);
            props.history.push(`/${status}/${project.id}/peform`);
        }
    }

    function resetForm() {
        setPreEForm(null);
        setPreEFormExceptions(null);
        setPreEFormMappings(null);
    }

    function handleEdit (){
        setSaveVisibleText(true);
    }

    async function downloadPdfForm(formId)
    {
        spinnerOn();
        const ret = await downloadPreEngPdfReport(project.id, formId);
        spinnerOff();
    }

    async function setViewFormDialog(formId){
        resetForm();
        spinnerOn();
        const preEForm = await getPreform(project.id, formId);
        let updatedPreEFormMappings = setAssets(preEForm);
        setPreEFormMappings(updatedPreEFormMappings);
        setPreEForm(preEForm);
        setFormMode(FORM_MODE_VIEW);
        setSaveVisibleText(false);
        spinnerOff();
        props.history.push(`/${status}/${project.id}/peform/${formId}`);
    }

    async function setEditFormDialog(formId){
        resetForm();
        spinnerOn();
        const preEForm = await getPreformEdit(project.id, formId);
        let updatedPreEFormMappings = setAssets(preEForm);
        setPreEFormMappings(updatedPreEFormMappings);
        setPreEForm(preEForm);
        setFormMode(FORM_MODE_EDIT);
        setSaveVisibleText(true);
        spinnerOff();
        props.history.push(`/${status}/${project.id}/peform/${formId}`);
    }

    async function setNewFormDialog() {
        spinnerOn();
        const preEForm = await getNewPreform(project.id);
        const preEFormMappings = preEForm.preFormMappings;
        if(preEFormMappings && preEFormMappings.length == 0)
        {
            spinnerOff();
            let msg = "All assets are selected......";
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <Alert msg={msg} onClose={onClose} style ={{width:"50%"}}/>

                    );
                }
            });
            return;
        }
        resetForm();
        const id = "new";
        let updatedPreEFormMappings = setAssets(preEForm);
        setPreEFormMappings(updatedPreEFormMappings);
        setPreEForm(preEForm);
        setFormMode(FORM_MODE_NEW);
        setSaveVisibleText(true);
        spinnerOff();
        props.history.push(`/${status}/${project.id}/peform/${id}`);
    }

    function closeErrorBox() {
        setError(null);
    }

    const onChangeFormTitle = value => {
        setPreEForm(prevState => {
            let nextState = {...prevState};
            nextState.formName = value;
            return nextState;
        });
    }

    const onChangeReqSos = async (value) => {
        let outage = null;
        if(value)
            outage = await getOutageRecord(value);
        setPreEForm(prevState => {
            let nextState = {...prevState};
            nextState.outageRecord = outage;
            nextState.reqSos = value;
            return nextState;
        });
    }

    function onChangePreEDate(date) {
        if (date) {
            setPreEForm(prevState => {
                let nextState = { ...prevState };
                nextState.preEnergizationDate = formatDate(date);
                return nextState;
            });
        }
    }

    const onEnergizedStatus = async (preformId, energized, onClose) => {
        const request = await createPreEFormRequest(preformId);
        let response = null;
        if(energized === 'Y')
            response = await undoPreEFormEnergization(request, project.id, preformId)
        else if(energized === 'N')
            response = await energizationPreEForm(request, project.id, preformId)
        if (response && response.errorMessages && response.errorMessages.length > 0){
            handleErrors(response.errorMessages[0]);
        } else {
            await updateFormState();
            props.history.push(`/${status}/${project.id}/peform`);
        }
        onClose();
    }

    async function savePreEForm(projectId) {
        const request = await createPreEFormRequest();

        if(!request.preform.formName || (request.preform.formName && request.preform.formName.trim().length === 0)){
            handleErrors("Please enter Title");
            return;
        }
        if(!request.preform.preEnergizationDate){
            handleErrors("Please enter Energization Date");
            return;
        }
        if(request.selectedIpsLocations.length === 0){
            handleErrors("Please select at least one Asset");
            return;
        }

        let response = null;

        if(formMode === FORM_MODE_NEW) {
            setError(null);
            response = await createPreform(request, projectId);
        } else {
            setError(null);
            response = await updatePreform(request, projectId, request.preform.id);
        }

        if(response && response.errorMessages && response.errorMessages.length > 0){
            handleErrors(response.errorMessages[0]);
        } else {
            await updateFormState();
            props.history.push(`/${status}/${projectId}/peform`);
        }
    }

    function handleErrors(err){
        setError(err);
        window.scrollTo(0,0);
    }

    async function createPreEFormRequest(preFormId){

        let updatedPreform = preEForm ? {...preEForm} : { ... await getPreform(project.id, preFormId) };
        let selectedIpsLocations = [];
        updatedPreform.outageRecord = null;

        Object.keys(updatedPreform).forEach(function(key) {
            if((key === 'formName' || key === 'reqSos' || key === 'preEnergizationDate' || key === 'comments') && updatedPreform[key] === null) {
                updatedPreform[key] = '';
            }
        });

        const mappings = preEFormMappings ? preEFormMappings : setAssets(updatedPreform);
        mappings.map(preEFormMapping => {
            let selectedIpsLocation = null;
            if(preEFormMapping.assets){
                let assetIds = [];
                preEFormMapping.assets.map(asset =>{
                    if(asset.selected && (!asset.formId || asset.formId === 0 || asset.formId ===  updatedPreform.id)) {
                        assetIds.push(asset.assetId);
                    }
                });
                if(assetIds && assetIds.length > 0){
                    selectedIpsLocation = {};
                    selectedIpsLocation.assetIds = assetIds;
                    selectedIpsLocation.ipsLocationId = preEFormMapping.ipsLocationId;
                }
            }
            if(selectedIpsLocation){
                selectedIpsLocations.push(selectedIpsLocation);
            }
        });
        return {
            preform: updatedPreform,
            selectedIpsLocations: selectedIpsLocations
        };
    }

    function formatDate(date) {
        return Moment(date).format('YYYY-MM-DD');
    }

    function onChangeAssetId(selectedAsset, selectedIpsLocId, setActive, setHeight){
        if(preEFormMappings) {
            const updatedPreEFormMappings = preEFormMappings.map(preEFormMapping => {
                let updatedPreEFormMapping = {...preEFormMapping};
                let allAssetsSelected = preEFormMapping.allAssetsSelected;
                let updatedAssets = preEFormMapping.assets.map(asset =>{
                    let updatedAsset = {...asset};
                    if(selectedAsset.assetId === asset.assetId && (!asset.formId || asset.formId === 0 || asset.formId ===  preEForm.id)){
                        updatedAsset = {
                            ...asset,
                            ...{selected: !asset.selected}
                        };
                    }
                    if(!updatedAsset.selected){
                        allAssetsSelected = false;
                    }
                    return updatedAsset;
                });
                updatedPreEFormMapping = {
                    ...updatedPreEFormMapping,
                    ...{assets : updatedAssets, allAssetsSelected : allAssetsSelected}
                };

                if(updatedPreEFormMapping.ipsLocationId && updatedPreEFormMapping.ipsLocationId === selectedIpsLocId) {
                    updatedPreEFormMapping = {
                        ...updatedPreEFormMapping,
                        ...{setActive : setActive, setHeight : setHeight}
                    };
                } else {
                    updatedPreEFormMapping = {
                        ...updatedPreEFormMapping,
                        ...{setActive : null, setHeight : "0px"}
                    };
                }

                return updatedPreEFormMapping;
            });
            setPreEFormMappings(updatedPreEFormMappings);
        }
    }

    function selectAllAssets(selectedIpsLocId) {
        if(preEFormMappings) {
            const updatedPreEFormMappings = preEFormMappings.map(preEFormMapping => {
                let updatedPreEFormMapping = {...preEFormMapping};
                if(preEFormMapping.ipsLocationId && preEFormMapping.ipsLocationId === selectedIpsLocId) {
                    let allAssetsSelected = !preEFormMapping.allAssetsSelected;
                    let updatedAssets = preEFormMapping.assets.map(asset => {
                        let updatedAsset = {...asset};
                        if ((!asset.formId || asset.formId === 0 || asset.formId === preEForm.id)) {
                            updatedAsset = {
                                ...asset,
                                ...{selected: allAssetsSelected}
                            };
                        }
                        return updatedAsset;
                    });
                    updatedPreEFormMapping = {
                        ...updatedPreEFormMapping,
                        ...{assets: updatedAssets, allAssetsSelected : allAssetsSelected}
                    };
                }
                return updatedPreEFormMapping;
            });
            setPreEFormMappings(updatedPreEFormMappings);
        }
    }

    function setAssets(preEForm) {
        const preEFormMappings = preEForm.preFormMappings;
        return preEFormMappings.map(preEFormMapping => {
            let updatedPreEFormMapping = { ...preEFormMapping };
            let allAssetsSelected = true;
            let enableIpsLoc = false;
            let updatedAssets = preEFormMapping.assets.map(asset => {
                let updatedAsset = { ...asset };
                let assetSelected = true;
                if (!asset.formId || asset.formId === 0) {
                    assetSelected = false;
                    allAssetsSelected = false;
                    enableIpsLoc = true;
                }
                if (!asset.formId || asset.formId === 0 || asset.formId === preEForm.id) {
                    enableIpsLoc = true;
                }
                updatedAsset = {
                    ...updatedAsset,
                    ...{ selected: assetSelected }
                }
                return updatedAsset;
            });
            const newAttributes = {
                assets: updatedAssets,
                allAssetsSelected: allAssetsSelected,
                enableIpsLoc: enableIpsLoc,
                setActive: null,
                setHeight: "0px"
            };
            updatedPreEFormMapping = {
                ...updatedPreEFormMapping,
                ...newAttributes
            };
            return updatedPreEFormMapping;
        });
    }

    return (
      <>
          <Switch location={location}>
              <Route
                exact
                key="peform"
                path={`/:state/:projectId/peform`}
                component={() =>
                  <PreEFormGrid project={project}
                                allForms={forms}
                                preEForm={preEForm}
                                onCreateForm={setNewFormDialog}
                                updateFormState={updateFormState}
                                updateExceptionsState={updateExceptionsState}
                                onEditForm={setEditFormDialog}
                                onViewForm={setViewFormDialog}
                                handleEdit={handleEdit}
                                onDeleteForm={deleteForm}
                                onEnergizedStatus={onEnergizedStatus}
                                onPdfForm={downloadPdfForm}
                                status={status}
                                handleRefreshCall={handleRefreshCall}
                                refreshPreEForms={refreshPreEForms}
                                refresh={refresh}
                  />}
              />
          </Switch>
          <Switch location={location}>
              <Route
                exact
                key="new"
                path={`/:state/:projectId/peform/:id`}
                component={() =>
                  <PreEFormDetails project={project}
                                     preEForm={preEForm}
                                     preEFormMappings = {preEFormMappings}
                                     assets={asset}
                                     onChangeFormTitle ={onChangeFormTitle}
                                     onChangeReqSos = {onChangeReqSos}
                                     onChangePreEDate = {onChangePreEDate}
                                     onChangeAssetId={onChangeAssetId}
                                     selectAllAssets={selectAllAssets}
                                     handlePreExceptionBack={handlePreExceptionBack}
                                     error={error}
                                     onCloseBox={closeErrorBox}
                                     onSave={savePreEForm}
                                     status={status}
                                     deleteForm={deleteForm}
                                     formMode={formMode}
                                     handleEdit={handleEdit}
                                     saveVisibleText={saveVisibleText}
                                     handleRefreshCall={handleRefreshCall}
                  />
                }
              />
          </Switch>
          <Switch location={location}>
              <Route
                exact
                key="showTasks"
                path={`/:state/:projectId/peform/:formId/showTasks`}
                component={() =>
                  <PreEFormTasks project={project} projectId={project.id} updateFormState={updateFormState} status={status} projectStatus={project.projectStatus}                                 handleRefreshCall={handleRefreshCall}/>}
              />
          </Switch>
          <Switch location={location}>
              <Route
                exact
                key="exceptions"
                path={`/:state/:projectId/peform/:formId/exceptions`}
                component={() =>
                  <PreEFormExceptionGrid project={project}
                                         preEForm={preEForm}
                                         preEFormExceptions={preEFormExceptions}
                                         updateFormState={updateFormState}
                                         updateExceptionsState={updateExceptionsState}
                                         status={status}
                                         handleRefreshCall={handleRefreshCall}
                  />
                }
              />
          </Switch>
          <Switch location={location}>
              <Route
                exact
                key="approvals"
                path={`/:state/:projectId/peform/:formId/exceptions/:exceptionId/approvals`}
                component={() =>
                  <PreEApprovals project={project}
                                 preEFormExceptions={preEFormExceptions}
                                 updateExceptionsState={updateExceptionsState}
                                 handleRefreshCall={handleRefreshCall}
                                 status={status}
                  />
                }
              />
          </Switch>
      </>
    );
}

export default withRouter(PreEForm);
